'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeLoadingObj = removeLoadingObj;
exports.createLoadingObj = createLoadingObj;

require('./index.css');

function creatLoadingDom() {
  var loadingText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请求中...';

  // 创建全局遮罩
  var mask = document.createElement('div');
  mask.classList.add('buzz-mask');
  mask.id = 'loading-obj';
  // 创建中间toast
  var obj = document.createElement('div');
  obj.classList.add('buzz-toast');
  // 创建旋转效果
  var loadOuter = document.createElement('div');
  loadOuter.classList.add('buzz-loading', 'buzz-loading--circular', 'buzz-loading--white', 'buzz-loading-margin');
  var load = document.createElement('div');
  // load.classList.add('loading');
  load.classList.add('buzz-loading__spinner', 'buzz-loading__spinner--circular');
  var svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
  svg.classList.add('buzz-loading__circular');
  svg.setAttribute('viewBox', '25 25 50 50');
  var circle = document.createElementNS("http://www.w3.org/2000/svg", 'circle');
  circle.setAttribute('cx', '50');
  circle.setAttribute('cy', '50');
  circle.setAttribute('r', '20');
  circle.setAttribute('fill', 'none');
  svg.appendChild(circle);
  load.appendChild(svg);
  loadOuter.appendChild(load);
  obj.appendChild(loadOuter);
  // 创建loading文字
  var text = document.createElement('p');
  text.id = 'loading-text';
  text.classList.add('buzz-text');
  text.innerHTML = loadingText;
  obj.appendChild(text);
  mask.appendChild(obj);
  document.body.appendChild(mask);
}

function removeLoadingObj() {
  try {
    var loadingObj = document.querySelector('#loading-obj');
    loadingObj.style.display = 'none';
    // bodyFixed(false);
  } catch (err) {
    console.log(err);
  }
}

function createLoadingObj() {
  var loadingText = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '请求中...';

  try {
    var loadingObj = document.querySelector('#loading-obj');
    // topOffest = document.documentElement.scrollTop || document.body.scrollTop;
    if (!loadingObj) {
      creatLoadingDom(loadingText);
      loadingObj = document.querySelector('#loading-obj');
    } else {
      document.querySelector('#loading-text').innerHTML = loadingText;
      loadingObj.style.display = 'block';
      var preventScroll = function preventScroll(e) {
        if (e.preventDefault) e.preventDefault();
        if (e.stopPropagation) e.stopPropagation();
      };
      if (loadingObj.addEventListener) {
        loadingObj.addEventListener('touchmove', preventScroll, false);
        loadingObj.addEventListener('mousewheel', preventScroll, false);
        loadingObj.addEventListener('scroll', preventScroll, false);
      }
    }
    var timer = setTimeout(function () {
      if (loadingObj && loadingObj.style.display !== 'none') removeLoadingObj();
      clearTimeout(timer);
    }, 4000);
  } catch (err) {
    console.log(err);
  }
}